import Reveal from "./Reveal";
import { professional } from "@/config/professional";

const highlights = [
  "Dificuldade de mobilidade",
  "Acompanhamento de feridas",
  "Idosos",
  "Recuperação",
  "Cuidados materno-infantis quando aplicável",
  "Acompanhamento próximo",
];

export default function HomeCare() {
  return (
    <section id="homecare" className="bg-secondary-50 py-16 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
          {/* Image */}
          <Reveal className="order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -left-4 -top-4 h-full w-full rounded-lg border border-primary-600/15" />
              <div className="relative overflow-hidden rounded-lg">
                <img
                  src={professional.homeCareImage}
                  alt="Atendimento Home Care com cuidado e acolhimento no conforto do lar"
                  className="h-[380px] w-full object-cover object-top md:h-[480px]"
                />
              </div>
            </div>
          </Reveal>

          {/* Copy */}
          <div className="order-1 lg:order-2">
            <Reveal>
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary-600">
                Home Care
              </p>
              <h2 className="mt-4 font-heading text-4xl font-semibold leading-[1.1] tracking-tight text-foreground-950 md:text-5xl">
                Cuidado especializado onde você se sente mais seguro.
              </h2>
              <p className="mt-5 text-base leading-relaxed text-foreground-600 md:text-lg">
                Atendimento Home Care com ciência, atenção e humanidade no
                conforto da sua casa.
              </p>
            </Reveal>

            <Reveal delay={80}>
              <ul className="mt-8 grid gap-3 sm:grid-cols-2">
                {highlights.map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-3 text-base text-foreground-700"
                  >
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-check-line text-sm" aria-hidden="true"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal delay={140}>
              <a
                href={professional.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group mt-9 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-600 px-7 py-4 text-base font-semibold text-background-50 transition-colors hover:bg-primary-700"
              >
                Agendar atendimento Home Care
                <i
                  className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"
                  aria-hidden="true"
                ></i>
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}